import langsEn from 'locales/en';
export const localize = (key, params = {}) => {
	const template = langsEn[key] || '';
	return template.replace(/{(\w+)}/g, (match, placeholder) => {
		return params[placeholder] !== undefined ? params[placeholder] : match;
	});
};
